import React from 'react';
import { Box, Alert, AlertTitle, TextField } from '@mui/material';
import { Field } from 'formik';
import { FormVisualResultsBulkReviewField, FormVisualResultsField } from '../fields/resultDetailFields';
import { NotesBulkReviewEditField, NotesEditField } from '../fields/fields';
import CheckIcon from '@mui/icons-material/Check';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import WarningAmberOutlinedIcon from '@mui/icons-material/WarningAmberOutlined';

interface VisualReviewCardProps {
  appInterpretation: string;
  userInterpretation?: string | null;
  userNotes?: string | null;
  isReviewed: boolean;
  reviewDate: string | null;
}

const VisualReviewCard: React.FC<VisualReviewCardProps> = ({
  appInterpretation,
  userInterpretation,
  userNotes,
  isReviewed,
  reviewDate
}) => {
  return (
    <Alert
      icon={false}
      severity={
        isReviewed ? 'info' : userInterpretation ? 'warning' : 'success'
      }
      sx={{
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <Box
        sx={{
          width: '100%',
          cursor: 'pointer',
          display: 'flex',
          gap: 1,
          alignItems: 'center',
          pb: 1,
        }}
      >
        {isReviewed ? (
          <>
            <CheckIcon fontSize="small" color="primary" />{' '}
            <AlertTitle sx={{ p: 0, m: 0, fontSize: '14px' }}>
              <strong>Reviewed:</strong> {reviewDate}
            </AlertTitle>
          </>
        ) : userInterpretation ? (
          <>
            <WarningAmberOutlinedIcon fontSize="small" color="warning" />{' '}
            <AlertTitle sx={{ p: 0, m: 0, fontSize: '14px' }}>
              <strong>Pending Review:</strong> App User Provided Interpretation
            </AlertTitle>
          </>
        ) : (
          <>
            <InfoOutlinedIcon fontSize="small" color="primary" />{' '}
            <AlertTitle sx={{ p: 0, m: 0, fontSize: '14px' }}>
              <strong>Pending Review</strong>
            </AlertTitle>
          </>
        )}
      </Box>
      <Box
        sx={{
          width: '100%',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
        }}
      >
        <Box
          sx={{
            width: '100%',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
          }}
        >
          <Box sx={{ width: '100%', px: 1 }}>
            <Box
              sx={{
                width: '100%',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                flexDirection: { xs: 'column', sm: 'row' },
                gap: { xs: 0.5, sm: '10px' },
              }}
            >
              <Field
                name="nothing"
                visualResult={appInterpretation}
                type="text"
                className="form-control"
                label="Initial App Interpretation"
                component={FormVisualResultsBulkReviewField}
              />
              vs
              <Field
                name="nothing"
                visualResult={userInterpretation}
                type="text"
                className="form-control"
                label={
                  isReviewed
                    ? 'Reviewer Interpretation'
                    : 'App User Interpretation'
                }
                component={FormVisualResultsBulkReviewField}
              />
            </Box>
          </Box>
        </Box>
        {userNotes ? (
          <Box sx={{ px: 1, width: '100%' }}>
            <Field
              name="reviewer_notes"
              type="text"
              className="form-control"
              label={isReviewed ? 'Reviewer Notes' : 'App User Notes'}
              rows={2}
              readOnlyMode
              component={NotesBulkReviewEditField}
            />
          </Box>
        ) : null}
      </Box>
    </Alert>
  );
};

export default VisualReviewCard;
